var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpClothActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#006EFF;}\r\n\t.st2{fill:#A3D7FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M763.6,125.8L646.8,67.4c-4.4-2.2-9.3-3.4-14.3-3.4H199.6c-5,0-9.9,1.2-14.3,3.4L68.5,125.8 c-2.7,1.4-4.4,4.2-4.4,7.2v179c0,4.4,3.6,8,8,8h120v376c0,4.4,3.6,8,8,8H432l24-64h-62.9l14.9-64l104-64l128-64h0.1V320h120 c4.4,0,8-3.6,8-8V132.9C768,129.9,766.3,127.1,763.6,125.8z M416,256c-70.7-0.1-127.9-57.3-128-128h256 C543.9,198.7,486.7,255.9,416,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M868.5,576l-33.2-116.4c-1.9-6.9-8.2-11.6-15.4-11.6H460c-7.1,0-13.4,4.7-15.4,11.6L408,576H868.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M956,882.2L886.8,640H393.1l-69.2,242.2c-2.3,7.9,1.8,16.3,9.5,19.3c196.9,78,416.2,78,613.1,0 C954.2,898.5,958.3,890.1,956,882.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpClothActive);
export default __webpack_public_path__ + "static/media/hp_cloth_active.fef84fd683ca803412604612d8eacb36.svg";
export { ForwardRef as ReactComponent };